import * as types from '../mutation-types'

const state = {
  main: []
}

const mutations = {
  [types.FETCH_PROFILE] (state, profile) {
    state.main = profile
  }
}

export default {
  state,
  mutations
}
